import { useState } from "react";
// import emailjs from "emailjs-com";
// import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  // ============================================
  // FORM SUBMISSION HANDLER
  // When demo mode is disabled, this will handle actual form submission
  // ============================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if in demo mode
    if (props.isDemoMode) {
      props.onDemoClick(e, 'Contact form submission');
      return;
    }
    
    // ============================================
    // PRODUCTION CODE (active when isDemoMode = false)
    // This handles the actual form submission
    // ============================================
    setLoading(true);
    setStatusMessage('');

    try {
      const response = await fetch(
        "https://func-ais-eus-contactme-demo-gkh5argzegeac7a3.eastus-01.azurewebsites.net/api/contactmeemailsend",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name, email, message })
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStatusMessage('✓ Email sent successfully!');
        clearState();
      } else {
        setStatusMessage(`✗ Error: ${data.message || 'Failed to send email'}`);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setStatusMessage('✗ Error sending email. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                {statusMessage && (
                  <div style={{
                    marginBottom: '20px',
                    padding: '12px',
                    borderRadius: '5px',
                    backgroundColor: statusMessage.includes('✓') ? '#d4edda' : '#f8d7da',
                    color: statusMessage.includes('✓') ? '#155724' : '#721c24',
                    border: `1px solid ${statusMessage.includes('✓') ? '#c3e6cb' : '#f5c6cb'}`
                  }}>
                    {statusMessage}
                  </div>
                )}
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                        value={name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        value={email}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 Mason Stark.
          </p>
        </div>
      </div>
    </div>
  );
};
